import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { SourceDataExtractionQueriesPopupComponent } from './source-data-extraction-queries-popup/source-data-extraction-queries-popup.component';
import { UploadExcelFileComponent } from '../upload-excel-file/upload-excel-file.component';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';

@Component({
    selector: 'app-source-data-extraction-queries',
    templateUrl: './source-data-extraction-queries.component.html',
    styleUrls: ['./source-data-extraction-queries.component.scss'],
    standalone: false
})
export class SourceDataExtractionQueriesComponent implements OnInit {

 frameworkComponent
  columnDefs
  defaultColDef
  paginationPageSize
  paginationNumberFormatter
  rowClassRules
  backgroundColor
  gridApi
  lastpage
  currentpage
  nextpage
  nextpageplusone
  totalpages
  pagesize
  components
  buttonColor
  backgroundColorScreen
  getdata
  updatedData: null;
  buttonName: any;
  bootstrapColumn: number;
   buttonIdList = []
  getRowStyle: (params: any) => { backgroundColor: string; };
  excelData: any;
  dnsId: string;
  tableName: string;
  /*
  Author- Venkata Shyam
  07-11-2025
  For creation of Source-Data-Extraction-Queries screen
 
*/

  constructor(private snackbar:MatSnackBar,private localStorrageSettings:LocalStorageSettingsService,private spinner:NgxUiLoaderService,
    private dialog: MatDialog,private commonService: CommonService,private userRoutingModule: UserRoutingModule,
     private reportLinkService:ReportlinksserviceService)
   {this.components ={
     buttonRenderer: Actionbutton,
   }}

  ngOnInit(): void {
     this.tableName= 'sqlscripts__j'
   this.dnsId = this.localStorrageSettings.getSettings("dnsName")
         let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorrageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        values:this.buttonIdList,
        edit: this.editIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 150
    },
      { headerName: 'Id', headerTooltip: 'Id', tooltipValueGetter: (params) => 'Id : ' + params.value, field: 'sqlscriptid__j', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'SQL Query', headerTooltip: 'SQL Query', tooltipValueGetter: (params) => 'SQL Query : ' + params.value, field: 'sqlscript__j', filter: 'agTextColumnFilter', width: 350 },
      { headerName: 'Pre Defined sqlscript Query', headerTooltip: 'Pre Defined sqlscript Query', tooltipValueGetter: (params) => 'Pre Defined sqlscript Query : ' + params.value, field: 'formated_sqlscript__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Format Date', headerTooltip: 'Format Date', tooltipValueGetter: (params) => 'Format Date : ' + params.value, field: 'automatically_formate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'File Name', headerTooltip: 'File Name', tooltipValueGetter: (params) => 'File Name : ' + params.value, field: 'filename__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Execution Order', headerTooltip: 'Execution Order', tooltipValueGetter: (params) => 'Execution Order: ' + params.value, field: 'executionorder__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Attachment Query', headerTooltip: 'Attachment Query', tooltipValueGetter: (params) => 'Attachment Query" : ' + params.value, field: 'attachmentquery__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Extraction Type', headerTooltip: 'Extraction Type', tooltipValueGetter: (params) => 'Extraction Type : ' + params.value, field: 'extractiontype__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Is Executable?', headerTooltip: 'Is Executable?', tooltipValueGetter: (params) => 'Is Executable? : ' + params.value, field: 'isExecutable__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Query Execution Type', headerTooltip: 'Query Execution Type', tooltipValueGetter: (params) => 'Query Execution Type", : ' + params.value, field: 'queryexecutiontype__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Data Source Name', headerTooltip: 'Data Source Name', tooltipValueGetter: (params) => 'Data Source Name: ' + params.value, field: 'sourceconnectionstring__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Data Source Type', headerTooltip: 'Data Source Type', tooltipValueGetter: (params) => 'Data Source Type: ' + params.value, field: 'sourcetype__j', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Group Name', headerTooltip: 'Group Name', tooltipValueGetter: (params) => 'Group Name : ' + params.value, field: 'objectgroupname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Set Split Required', headerTooltip: 'Set Split Required', tooltipValueGetter: (params) => 'Set Split Required: ' + params.value, field: 'setssplitrequired', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Group Extraction Type', headerTooltip: 'Group Extraction Type', tooltipValueGetter: (params) => 'Group Extraction Type : ' + params.value, field: 'groupextractiontype', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Object Names', headerTooltip: 'Object Names', tooltipValueGetter: (params) => 'Object Names : ' + params.value, field: 'objectnamesvalueslist', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250,  
        cellStyle: function (params){
          if (params.value == 'Yes'){
            return { color: 'green' };
          } else {
            return { color: 'red' };
          }
        } 
      },
      
    ],

    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };

    this.buttonColor = this.localStorrageSettings.getSettings("ColorA")
    this.backgroundColorScreen = this.localStorrageSettings.getSettings("ColorD")

  }
  
  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }
  onGridReady(params){
    this.gridApi = params;
    params.api.setGridOption('rowData', [])
    this.spinner.start()
    var tenantId = localStorage.getItem('dnsName');
     console.log(tenantId)
     this.retrieve(tenantId)
  }

  refreshRun() {
    this.spinner.start();
    this.onGridReady(this.gridApi);
    this.spinner.stop();
  }

  retrieve(tenantId){
    console.log("inside retrival")
    this.commonService.retrieveSourceExtractionQueriesByTenantId( this.dnsId).subscribe(response=>{
      if(response.error == true){
        this.spinner.stop();
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        this.gridApi.api.setGridOption('rowData', this.getdata)
      }else{
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        this.gridApi.api.setGridOption('rowData', this.getdata)
        this.spinner.stop();
      }
     
    })
  }

   
  openSaveForm(buttonName) {
    this.buttonName = buttonName;
   
    let width = '80%';

    if (this.bootstrapColumn == 1) {

      width = '55%';

    }
    var obj={}
    let dialogRef = this.dialog.open(SourceDataExtractionQueriesPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '60%',
      // height:'100%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
     //  this.retrieveAssignUsersRoleByDnsId();

     if (this.gridApi) {
      this.onGridReady(this.gridApi); // Call onGridReady after the popup closes
  }
    });
    
  }

    editIcon(e) {
      let rowData = e.rowData;
      console.log(e.rowData);
      console.log(e.rowData);
      var obj = e.rowData
      console.log(obj);
      console.log(event);
      if(e.rowData.status === "No"){
        this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
        return;
      }
      let dialogRef = this.dialog.open(SourceDataExtractionQueriesPopupComponent, {
        panelClass: 'custom-dialog-container-materialFulfilment',
        width: '60%',
        autoFocus: false,
        data: { edata: obj},
        disableClose: true,
      });
  
      dialogRef.afterClosed().subscribe(result=>{
        if (this.gridApi) {
          this.onGridReady(this.gridApi); // Call onGridReady after the popup closes
      }
      })
  
    }

    
  deleteIcon(event) {
    console.log(event);
    if(event.rowData.status === "No"){
      this.snackbar.open("Selected record is already deleted","OK",{duration:5000});
      return;
    }
    if(confirm("Are you sure you want to delete this record?")){
      this.spinner.start();
      this.commonService.deleteSourceExtractionQueries(event.rowData.sqlscriptid__j).subscribe(result=>{
        if(result.statusMessage === "Successfully record is deleted"){
          this.snackbar.open(result.statusMessage, "OK",{duration:5000});
        }else{
          this.snackbar.open("Cannot delete selected record", "OK",{duration:5000});
        }
        this.refreshRun();
        this.spinner.stop();
      });
    }
    
  }

       
  excelFileUploadForObjects(){
    const tablename= 'sqlscripts__j'
    let selectedNameOfdns
    selectedNameOfdns = this.localStorrageSettings.getSettings("dnsName")
    console.log(selectedNameOfdns)
    let dialogRef = this.dialog.open(UploadExcelFileComponent, {
                panelClass: 'custom-dialog-container-materialFulfilment',
                width: '95%',
                height:'80%',
                maxWidth:'100vw',
                autoFocus: false,
                data: { edata:tablename,dnsname:selectedNameOfdns},
                disableClose: true,
              });
              dialogRef.afterClosed().subscribe(result => {
              console.log(result)
               if(result){
                this.excelData = result
                  this.refreshRun()
              //  this.sendExcelData()
               }
                  this.refreshRun()
              //  input.value = '';
            })
        
    }
    
  
  
    importData() {
      // if (this.headerNameHtml == "Objects") {
      //   this.importExportTableName = "objectmetadata    ";
  
      //  }
      
          console.log("<--- Inside upload Group Template --->")
          let width = "85%";
        let dialogRef = this.dialog.open(ImportJsonComponent, {
            maxWidth: "70vw",
            height: "50%",
            width: width,
          data: { "tablename": this.tableName,tenantid:this.dnsId},
            disableClose: true,
          });
        
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
        
            //this.reportCreationData = result;
        
            //this.vaultObjectService.retrieveobjectgroup();
          });
        
        
      }
      
    
      async exportData() {
        this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
        let tenantid = localStorage.getItem("dnsName")
  
        // if (this.headerNameHtml == "Objects") {
        //   this.importExportTableName = "objectmetadata";
        //   tenantid = this.dnsid+"";
  
        // }
       
    
          try {
            const blob = await this.commonService.downloadJsonFile(this.tableName, tenantid);
            const link = document.createElement('a');
            const timestamp = new Date().getTime();
            link.href = window.URL.createObjectURL(blob);
            link.download = `${this.tableName}_export_${timestamp}.json`;
            link.click();
            window.URL.revokeObjectURL(link.href);
    
          } catch (error) {
            console.error('Error downloading JSON:', error);
          }
        
        
      }

}
